module.exports = __webpack_public_path__ + "static/media/Activities_Placeholder.8568ade2.svg";